import React, {Proptype, Component} from 'react'
import classnames from 'classnames'
import {connect} from 'react-redux'
import { Table } from 'components/UI'
import {browserHistory} from 'react-router'
import TeacherNameTd from './TeacherNameTd.js'
import TeacherStatusTd from './TeacherStatusTd.js'
import {confirm} from 'util/confirm'
import {alert} from 'util/alert'
import archiveTeacher from 'controllers/teacher/archiveTeacher'
import inviteTeacher from 'controllers/teacher/inviteTeacher'
import {fetchCurrentTeacher, fetchArchivedTeacher} from '../ducks'

import './TeacherTable.scss'

const CONTROLLER_WIDTH = '170px'

const mapStateToProps = (state) => ({

})

class TeacherTable extends Component {
  constructor(props){
    super(props)
  }

  render(){
    let {tableData, settings, pagination, onItemsCountPerPageChange, onPageChange} = this.props

    const fields = [{
      name: 'tName',
      title: __('Teacher Name', 'teacher'),
      getTdProps: ({tbodyData})=>{
        return {
          className: "student-info",
          style: {
            width: "20%"
          }
        }
      },
      getTdContent: ({ trData: teacher })=>{
        return <TeacherNameTd teacher={teacher} />
      },
    }, {
      name: 'tPhone',
      title: __('Phone Number', 'teacher'),
      getTdProps: ({tbodyData})=>{
        return {
          style: {
            width: "15%"
          }
        }
      },

    },{
      name: 'tEmail',
      title: __('Email', 'createstudent'),
      getTdProps: ({tbodyData})=>{
        return {
          style: {
            width: "20%"
          }
        }
      },
    }, {
      name: 'taughttimes',
      title: __('Lessons Taught Count', 'teacher'),
      getTdProps: ({tbodyData})=>{
        return {
          style: {
            width: "10%"
          }
        }
      },
    }, {
      name: 'taughthours',
      title: __('Lessons Taught Hours', 'teacher'),
      getTdProps: ({tbodyData})=>{
        return {
          style: {
            width: "10%"
          }
        }
      },
    }, {
      name: 'stState',
      title: __('Status', 'class'),
      getTdContent: ({ trData: teacher })=>{
        return <TeacherStatusTd teacher={teacher} />
      },
      getTdProps: ({tbodyData})=>{
        return {
          style: {
            width: "12%"
          }
        }
      },
    }]

    return(
      <Table
        data={tableData}
        fields={fields}
        className='teacher-table'
        settingThTitle={__('Settings', 'class', null, true)}
        settingWidth={CONTROLLER_WIDTH}
        settings={settings}
        useMultiSelection={false}
        oneSettingPerRow={false}

        dropdownGuideWidth={160}
        dropdownGuideHeight={228}

        usePagination={true}
        pagination={pagination}
        onPageChange={onPageChange}
        onItemsCountPerPageChange={onItemsCountPerPageChange}
      />
    )
  }
}


export default connect(mapStateToProps)(TeacherTable)



// WEBPACK FOOTER //
// ./src/containers/pages/Teacher/TeacherTable/index.js